import { ProductType } from '../constants/productTypes';
import { statesByProductType } from '../constants/states';
import { ProductBuilderMachineState } from '../types';

type GetStatesForProductType = (
  productType: ProductType,
) => ProductBuilderMachineState[];

export const getStatesForProductType: GetStatesForProductType = productType => {
  return productType in statesByProductType
    ? statesByProductType[productType]
    : [];
};
